var DateTimeServiceModule = /** @class */ (function () {
    function DateTimeServiceModule() {
    }
    return DateTimeServiceModule;
}());
export { DateTimeServiceModule };
